export default {"src":"/_next/static/media/mindfulness-activities-relaxing.colour.3ab51a3f.svg","height":364,"width":364,"blurWidth":0,"blurHeight":0};